import moment from 'moment';

export enum CropZoneMatchType {
  ANY = 'ANY',
  ALL = 'ALL'
}

export interface CropZoneFilterItem {
  id: string;
  name: string;
  area?: number;
  fieldName?: string;
  fieldId?: string;
  [key: string]: any;
}

export interface FilterFormikData {
  dateRange: [moment.Moment, moment.Moment] | [];
  cropZoneIds: string[];
  cropZones: CropZoneFilterItem[];
  totalArea: number | null;
  sourceType: string | null;
  matchType: CropZoneMatchType;
}

export const initialValues: FilterFormikData = {
  dateRange: [],
  cropZoneIds: [],
  cropZones: [],
  totalArea: null,
  sourceType: null,
  matchType: CropZoneMatchType.ANY
};
